import React, { useEffect, useState } from "react";
import PanelError from "../PanelError";
import ButtonRestartApp from "../ButtonRestartApp";
import PageContent from "../PageContent";
import { useDispatch } from "react-redux";
import { getConfiguration } from "../../logic/actions/api/configuration";

export default function ApplicationConfig({ children }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    getConfiguration()(dispatch)
      .then(() => {
        setLoaded(true);
      })
      .catch((err) => {
        setError("Failed to load application. Check your internet connection");
      });
  }, [dispatch]);

  if (loaded) return children;

  if (error)
    return (
      <PageContent>
        <PanelError text={error} />
        <ButtonRestartApp />
      </PageContent>
    );

  return (
    <PageContent showVersion={true}>
      <header />
      <h1>Loading configuration...</h1>
    </PageContent>
  );
}
